let Barba = require('barba.js');
import Swiper from 'swiper/dist/js/swiper';

module.exports = Barba.BaseView.extend({
    namespace: 'company-page',

    onEnterCompleted() {
        let buttons = $('.company-tabs__menu-element');
        let tabs = $('.company-tabs__content-container');

        setActiveTab(0);

        buttons.click(function () {
            setActiveTab($(this).index());
        });

        new Swiper('.slider__holder', {
            speed: 400,
            loop: true,
            navigation: {
                nextEl: '.slider__arrow_right',
                prevEl: '.slider__arrow_left',
            },
            pagination: {
                el: '.slider__pagination',
                type: 'bullets',
                bulletClass: 'slider__pagination-dot',
                bulletActiveClass: 'slider__pagination-dot_active',
                clickable: true,
            },
            autoplay: {
                delay: 4000,
            },
        });

        function setActiveTab(index) {
            buttons.removeClass('company-tabs__menu-element_active');
            buttons.eq(index).addClass('company-tabs__menu-element_active');
            tabs.removeClass('company-tabs__content-container_visible');
            setTimeout(function () {
                tabs.removeClass('company-tabs__content-container_block');
                tabs.eq(index).addClass('company-tabs__content-container_block');
                setTimeout(function () {
                    tabs.eq(index).addClass('company-tabs__content-container_visible');
                }, 10);
            }, 200);
        }
    },

    onLeave() {

    }
});


// WEBPACK FOOTER //
// resources/assets/src/js/views/company-page.js